var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM50(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5433_45339",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5433_45339",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABx0lEQVRo3uWa0W2DMBCGeWKCPjWeIBmHZ9oF4IW+whQoczQTsEASiQyQDBFC3ox7V9kSUVMwLhgftfQ/JMJ39yXYPvvseSM0IQQDhaAcVIAuoArEpSr5XSGfwWeZN2d7/Qxf2O494U2zh2AaMbw10PeANtCWzcBXoC3oznZvEATnwrBhX7SBtqTN1ZSB+6AMVIMEakQAIVVLH/7YwW9AZcvRVABKJ/Q5VvAB6PbEyZQAQvoM/jC1fAcfg/gvDqYGENJ3bPrLY/Bdxm0ACBlDbPLa8B7DtgDUPxEMGbA3DaM2AdSY2OhMlSdNg7YB1OzkdwFkA4zNAYDKulbYmgBA/XTFlku5IACA2v5IzGQ+QgXg/pAAwocPAyNzAqCSNsCRIMBRBc/6VlxHAbAfQ4DQ0MDcAKgQAXLCADkCFIQBCgS4EAY4I0BFGKDydNJmhwH4IgAov0LXRQxi8tMo+YWMfCpBO5kjnE4f2vuBhPqGhvaWkvymfhHHKoQOttK+o8XSYYCyt3rj+OHuevnH6y2IyKECR2RapYkcKDFF/7TI9wixtlxmLbUH7MBCd2qh0J2OXuhexFWDiS577K1f9tC8bnMGXW1ct/kC8kz8+T/kqj4AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM50);
export default __webpack_public_path__ + "static/media/m50.17a5a137905ffbc4ad521cba1239e29f.svg";
export { ForwardRef as ReactComponent };